
import Vue from "vue";
import AppLedgerAccountAutocomplete from "@/components/common/LedgerAccountAutocomplete.vue";
import { Product } from "@/models/base";

export default Vue.extend({
	props: {
		product: {
			type: Object as ()=>Product,
			required: true
		}
	},
	components: {
		AppLedgerAccountAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
